import Base from "../Base";

class Manager extends Base{
	constructor(props: string){
		super(props)
		this.res = {
			'code':300,
			'msg':'网络出错,未获取到数据'
		}
	}
	/**
	 * 查询用户
	 * @param data IParams
	 * @returns 
	 */
	 async login(data:{
		username:string;
		password:string;
		vcode?:string;
	 }):Promise<IManager.IResData<{access_token:string, refresh_token:string, username:string}>>{
		return await this.HttpPost('login',data)
	}
}

export default Manager;